import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { readonly } from 'vue';
export var currentTabInjectKey = Symbol('az.tabs.current');
export default /*#__PURE__*/_defineComponent({
  __name: 'AzTabs',
  props: {
    value: null
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var slots = useSlots();
    var tabs = computed(function () {
      var _slots$default;
      return slots === null || slots === void 0 ? void 0 : (_slots$default = slots.default()) === null || _slots$default === void 0 ? void 0 : _slots$default.flatMap(function (slot) {
        var _slot$tag;
        if (!((_slot$tag = slot.tag) !== null && _slot$tag !== void 0 && _slot$tag.endsWith('AzTab'))) return [];
        return [slot.componentOptions.propsData];
      });
    });
    var currentTabId = computed(function () {
      var _tabs$value$find$id, _tabs$value$find, _tabs$value;
      return (_tabs$value$find$id = (_tabs$value$find = tabs.value.find(function (tab) {
        return tab.id === props.value;
      })) === null || _tabs$value$find === void 0 ? void 0 : _tabs$value$find.id) !== null && _tabs$value$find$id !== void 0 ? _tabs$value$find$id : (_tabs$value = tabs.value) === null || _tabs$value === void 0 ? void 0 : _tabs$value[0].id;
    });
    var currentTabIndex = computed(function () {
      return tabs.value.findIndex(function (tab) {
        return tab.id === props.value;
      });
    });
    function selectTab(id) {
      if (!tabs.value.find(function (tab) {
        return tab.id === id;
      })) return;
      emit('input', id);
    }
    provide(currentTabInjectKey, readonly(currentTabId));
    return {
      __sfc: true,
      currentTabInjectKey: currentTabInjectKey,
      props: props,
      slots: slots,
      emit: emit,
      tabs: tabs,
      currentTabId: currentTabId,
      currentTabIndex: currentTabIndex,
      selectTab: selectTab
    };
  }
});